import React, { useEffect, useState } from 'react';
import fetch from 'isomorphic-fetch';
import { Achievement } from '../Achievement/Achievement';
import { achievementsList as fullAchievementsList } from '../../constants/achievements';

import { Achievements as AchievementsType } from '../../constants/achievements';
import { Cat } from '../../types';

type Props = {
    cat: Cat;
}

type Counter = {
    alias: AchievementsType;
    catId: string;
    count: number;
    id: string;
}

const getCoord = (deg: number): { left: number; top: number } => { // хуёво считает от ноля
    const rad = deg * (Math.PI / 180);
    const x = Math.cos(rad) * 50;
    const y = Math.sin(rad) * 50;

    return {
        left: 50 + x,
        top: 100-(50 + y)
    };
};

const getDeg = (num: number) => {
    const sign = (num % 2) === 0 ? -1 : 1;
    const count = Math.floor(num / 2);

    return 90 + (sign * (count * 28));
};

export const Achievements = ({ cat }: Props) => {
    const [achievementsList, setAchievementsList] = useState<AchievementsType[]>([]);

    useEffect(() => {
        (async () => {
          const response = await fetch(`/cats/api/achievements?catId=${cat.id}`);
          const { items } = await response.json() as { items: Counter[] };
          
          if (!Array.isArray(items)) {
            return;
          }

          const achievements = items.reduce<AchievementsType[]>((acc, counter) => {
            if (!fullAchievementsList.includes(counter.alias)) {
                return acc;
            }

            acc.push(counter.alias);

            return acc;
          }, []);

          setAchievementsList(achievements);
        })();
      }, []);

    let indexCounter = 1;

    const achievementsEl = [];

    for (let i = 0; i < fullAchievementsList.length; ++i) {
        const achievement = fullAchievementsList[i];
        const isHidden = !achievementsList.includes(achievement);

        achievementsEl.push(
            <Achievement
                isHidden={!achievementsList.includes(achievement)}
                achievement={achievement}
                {...getCoord(getDeg(indexCounter))}
            />
        );

        if (!isHidden) {
            ++indexCounter;
        }
    }

    console.log('achievementsList', achievementsList, achievementsEl);

    return (
        <>
            {achievementsEl}
        </>
    )
}